import FormViewModalsManager from './FormViewModalsManager'

export default FormViewModalsManager
